// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0eb2b00b","455":"fcd3e698"}[chunkId] + ".chunk.js";
};